import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71dfe0c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "titled-layout" }
const _hoisted_2 = {
  key: 0,
  class: "titled-layout_title"
}
const _hoisted_3 = { class: "titled-layout_body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "titled-layout_text-come-back" }, "Назад", -1))

import { computed, useSlots } from 'vue';
import { RouterLink } from 'vue-router';
import { ArrowUturnLeftIcon } from 'tir-style-system/icons/outline';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'titled-layout',
  props: {
  /**Путь назад */
  backPath: { type: String },
},
  setup(__props) {

const props = __props;


/**Слоты */
const slots = useSlots();

/**Слот заголовка */
const titleSlot = computed(() => slots.title?.());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (titleSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "title")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (__props.backPath)
        ? (_openBlock(), _createBlock(_unref(RouterLink), {
            key: 0,
            class: "titled-layout_back",
            to: __props.backPath
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowUturnLeftIcon), { class: "titled-layout_back_icon" }),
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})